import type { AppRequestRoute } from './types'

import routes from './routes'

type ParamPrimitive = string | number | boolean
type ParamValue = ParamPrimitive | ParamPrimitive[]

export const useCsRoutes = (name: AppRequestRoute, params?: Record<string, ParamValue>): string | null => {
  const { public: { appUrl: baseUrl } } = useRuntimeConfig()
  let path = (routes as Record<string, string>)[name]
  if (!path) return null

  const qs = new URLSearchParams()

  const norm = (v: ParamPrimitive) =>
    typeof v === 'boolean' ? (v ? '1' : '0') : String(v)

  if (params) {
    for (const [key, value] of Object.entries(params)) {
      if (!Array.isArray(value) && path.includes(key)) {
        path = path.replace(key, norm(value))
        continue
      }

      if (Array.isArray(value)) {
        const arrKey = `${key}[]`
        for (const item of value) qs.append(arrKey, norm(item))
      } else {
        qs.append(key, norm(value))
      }
    }
  }

  const query = qs.toString()
  return `${baseUrl}${path}${query ? `?${query}` : ''}`
}
